import { API_CONFIG } from '../config/api';

// 카카오 로그인 콜백 처리
export const handleKakaoCallback = (): { code: string | null; error: string | null } => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');
    
    console.log('Current URL:', window.location.href);
    console.log('URL search params:', window.location.search);
    console.log('Parsed code:', code);
    console.log('Parsed error:', error);
    
    if (error) {
      console.error('카카오 로그인 오류:', error);
      return { code: null, error };
    }
    
    if (code && code.trim()) {
      console.log('카카오 인증 코드 받음:', code);
      return { code: code.trim(), error: null };
    }
    
    console.warn('코드나 에러가 없습니다. URL:', window.location.href);
    return { code: null, error: null };
  } catch (err) {
    console.error('URL 파싱 에러:', err);
    return { code: null, error: 'URL 파싱 실패' };
  }
};

// URL 파라미터 정리 함수 (처리 완료 후 별도로 호출)
export const clearUrlParameters = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

// 올바른 OAuth 플로우: 내 서버를 통해 카카오 로그인 처리
export const exchangeCodeForToken = async (code: string): Promise<any> => {
  try {
    // 환경에 따른 redirectUri 설정
    const redirectUri = `${window.location.origin}/kakao/callback`

    console.log(`카카오 콜백 API 호출: ${API_CONFIG.baseURL}/api-web/v1/gth-auth/kakao/oauth/callback`);
    
    // 새로운 API 클라이언트 사용
    const response = await fetch(`${API_CONFIG.baseURL}/api-web/v1/gth-auth/kakao/oauth/callback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // 쿠키를 포함하여 요청 (refresh token 용)
      body: JSON.stringify({
        code: code,
        redirectUri: redirectUri
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || '로그인 처리 실패');
    }

    const userData = await response.json();
    console.log('서버에서 받은 사용자 데이터:', userData);
    
    // 최신 토큰 처리 방식: accessToken만 localStorage에 저장
    // refreshToken은 서버에서 HttpOnly 쿠키로 설정됨
    if (userData.result?.tokenDto?.accessToken) {
      localStorage.setItem('accessToken', userData.result.tokenDto.accessToken);
      // refreshToken은 더 이상 localStorage에 저장하지 않음 (HttpOnly 쿠키)
    }
    
    return userData;
  } catch (error) {
    console.error('카카오 로그인 처리 오류:', error);
    throw error;
  }
};